import { useEffect, useState } from "react";
import { userProfileData } from "../../Common/profileInfo";
import { clientConfig } from "../../awsClientConfig";
import { GetPartner } from "../../queries/GetPartner";

export default function WelcomeBack(this: any) {

    const [partnerName, setPartnerName] = useState("");
    const client = new clientConfig();

    const getPartner = async () => {
        const partnerId = await userProfileData();
        client
            .query({
                query: GetPartner,
                variables: { PartnerId: partnerId },
            })
            .then((res: any) => {
                setPartnerName(
                    `${res.data.GetPartner.FirstName} ${res.data.GetPartner.LastName}`
                );
            });
    };

    useEffect(() => {
        getPartner();
    }, []);

    return (
        <section className="welcomeBack">
            <h1 className="pageHeading">
                {`Welcome Back, ${partnerName}`}
            </h1>
        </section>
    );
}